import { InformationSVG } from './assets/information';
import { SuccessSVG } from './assets/success';
import { WarningSVG } from './assets/warning';
export var bannerIconData = {
    bannerIcon: [
        {
            name: 'default',
            svg: InformationSVG,
            svgHeight: 24,
            svgWidth: 24,
        },
        {
            name: 'info',
            svg: InformationSVG,
            svgHeight: 24,
            svgWidth: 24,
        },
        {
            name: 'warning',
            svg: WarningSVG,
            svgHeight: 24,
            svgWidth: 24,
        },
        {
            name: 'alert',
            svg: WarningSVG,
            svgHeight: 24,
            svgWidth: 24,
        },
        {
            name: 'success',
            svg: SuccessSVG,
            svgHeight: 24,
            svgWidth: 24,
        },
        {
            name: 'error',
            svg: WarningSVG,
            svgHeight: 24,
            svgWidth: 24,
        },
    ],
};
